import { CloudDiscoveryKey } from '../../utils/contexts';
import { AdminDeploymentDetail } from '../MLOps/AdminDeploymentDetail';
import { AdminDeployments } from '../MLOps/AdminDeployments';
import AdminModelDetail from '../MLOps/AdminModelDetail';
import { AdminModels } from '../MLOps/AdminModels/AdminModels';
import BatchScoring from '../MLOps/BatchScoring';
import BatchScoringDetail from '../MLOps/BatchScoringDetail';
import MLOpsDashboard from '../MLOps/Dashboard';
import DeploymentDetail from '../MLOps/DeploymentDetail';
import Deployments from '../MLOps/Deployments';
import ModelDetail from '../MLOps/ModelDetail';
import Models from '../MLOps/Models';
import TagsManagement from '../MLOps/TagsManagement';
import { MLOpsUserActionType, resourceMLOps } from '../MLOps/userActions';
import { RoutePaths } from '../RoutePaths';
import type { RouteDefinition } from './routeDefinitions';

const sharedParams: Partial<RouteDefinition> = {
  exact: true,
  requiresDiscoveryKey: CloudDiscoveryKey.mlopsApiUrl,
  requiresEnvCondition: (env) => env.mlopsUiEnabled,
};

const authParams: Partial<RouteDefinition> = {
  ...sharedParams,
  requiresAuth: true,
  requiresWorkspaces: true,
};

const adminParams: Partial<RouteDefinition> = {
  ...sharedParams,
  requiresAdmin: true,
};

const getMLOpsActions = (actions: MLOpsUserActionType[], resource?: string) => {
  return actions.map((action) => (resource ? { action, resource } : { action }));
};

export const MLOPS_ROUTE_DEFINITIONS: RouteDefinition[] = [
  // Authenticated routes
  {
    ...authParams,
    path: RoutePaths.MLOPS_ENTRY,
    requiresAuthzPermissionAND: getMLOpsActions([
      MLOpsUserActionType.MLOPS_MODEL_REGISTRY_LIST,
      MLOpsUserActionType.MLOPS_MODEL_REGISTRY_LIST_VERSION,
      MLOpsUserActionType.MLOPS_EXPERIMENTS_GET,
    ]),
    render: () => <MLOpsDashboard />,
  },
  {
    ...authParams,
    path: RoutePaths.MLOPS,
    render: () => <MLOpsDashboard />,
  },
  {
    ...authParams,
    path: RoutePaths.MLOPS_MODEL_TAGS_MANAGEMENT,
    render: () => <TagsManagement />,
  },
  {
    ...authParams,
    path: RoutePaths.MLOPS_MODELS,
    requiresAuthzPermissionAND: getMLOpsActions([
      MLOpsUserActionType.MLOPS_DEPLOYMENTS_CREATE,
      MLOpsUserActionType.MLOPS_DEPLOYMENTS_LIST,
    ]),
    render: () => <Models />,
  },
  {
    ...authParams,
    path: RoutePaths.MLOPS_MODEL_DETAIL,
    render: () => <ModelDetail />,
  },
  {
    ...authParams,
    path: RoutePaths.MLOPS_DEPLOYMENTS,
    requiresAuthzPermissionAND: getMLOpsActions([
      MLOpsUserActionType.MLOPS_BATCH_SCORING_JOBS_CREATE,
      MLOpsUserActionType.MLOPS_BATCH_SCORING_JOBS_LIST,
    ]),
    render: () => <Deployments />,
  },
  {
    ...authParams,
    path: RoutePaths.MLOPS_DEPLOYMENT_DETAIL,
    render: () => <DeploymentDetail />,
  },
  {
    ...authParams,
    path: RoutePaths.MLOPS_BATCH_SCORING,
    render: () => <BatchScoring />,
  },
  {
    ...authParams,
    path: RoutePaths.MLOPS_BATCH_SCORING_DETAIL,
    render: () => <BatchScoringDetail />,
  },

  // Admin routes
  {
    ...adminParams,
    path: RoutePaths.MLOPS_ADMIN_DEPLOYMENTS,
    requiresAuthzPermissionAND: getMLOpsActions([MLOpsUserActionType.MLOPS_DEPLOYMENTS_LIST_ALL], resourceMLOps),
    render: () => <AdminDeployments />,
  },
  {
    ...adminParams,
    path: RoutePaths.MLOPS_ADMIN_DEPLOYMENT_DETAIL,
    render: () => <AdminDeploymentDetail />,
  },
  {
    ...adminParams,
    path: RoutePaths.MLOPS_ADMIN_MODELS,
    requiresAuthzPermissionAND: getMLOpsActions([MLOpsUserActionType.MLOPS_MODEL_REGISTRY_LIST_ALL], resourceMLOps),
    render: () => <AdminModels />,
  },
  {
    ...adminParams,
    path: RoutePaths.MLOPS_ADMIN_MODEL_DETAIL,
    render: () => <AdminModelDetail />,
  },
];
